import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { AbvPbmRateAddDialog } from './AbvPbmRateAddDialog';

export const AbvPbmRateAddButton = ({ lbeId }) => {

  const { openDialog } = useDialog();

  const handleOpen = () => {
    openDialog(AbvPbmRateAddDialog, { lbeId });
  }

  return (
    <>
      <TitleButton
        dataTestId="pbm-rate-add-button"
        icon={fas.faPlus}
        toolTip="Add PBM Rate"
        onClick={handleOpen}
      />
    </>
  );
};
